































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { ImportedFivFile, ImportedFivFileModel } from 'admiral-core';
import { CheckCircleIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { PolicyApi } from '@/services/PolicyApi';
import { Util } from '@/utils/Util';
import { BModal } from 'bootstrap-vue';

@Component({
  components: {
    UserSelect,
    XIcon,
    CheckCircleIcon,
  },
})
export default class ConfirmPolicyImportModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ type: Object })
  importedFivFile!: ImportedFivFile;

  model = this.defaultModel();

  importedPoliciesNumber = 0;
  counting = false;

  defaultModel(): ImportedFivFileModel {
    return {
      ...this.importedFivFile,
    };
  }

  @Watch('importedFivFile', { immediate: true })
  watchImportedFivFile() {
    this.importedPoliciesNumber = 0;
    this.model = { ...this.importedFivFile };
  }

  async mounted() {
    this.model = { ...this.defaultModel() };
    this.isDone = false;
    this.isLoading = false;
  }

  get userMap() {
    return Object.keys(this.importedFivFile.usersMap);
  }

  async startCounting() {
    this.counting = true;
    this.importedPoliciesNumber = 0;
    while (this.importedPoliciesNumber < this.importedFivFile.policies.length && this.counting) {
      await Util.wait(2);
      this.importedPoliciesNumber++;
    }
  }
  stopCounting() {
    this.counting = false;
  }

  closeImport() {
    this.$nextTick(() => {
      (this.$refs['confirm-policy-import'] as BModal).hide();
    });
    this.$emit('imported');
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;
      this.startCounting();
      this.$Progress.start();

      const response = await PolicyApi.importFromFiv({
        importedFivFile: this.model as ImportedFivFile,
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.isDone = true;
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
      this.stopCounting();
      this.$Progress.finish();
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen Ziel Namen eingeben angeben.');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
